import { render } from "./MovimentosFechados.vue?vue&type=template&id=0ff2aeb0&scoped=true"
import script from "./MovimentosFechados.vue?vue&type=script&lang=js"
export * from "./MovimentosFechados.vue?vue&type=script&lang=js"

import "./MovimentosFechados.vue?vue&type=style&index=0&id=0ff2aeb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2aeb0"]])

export default __exports__